import { useEffect } from 'react';

import { useStores } from '../../hooks';
import { IframeVideo } from '../../components/IframeVideo';

import styles from './styles/main.module.scss';

export const IframeVideoContainer = ({ idForScroll }) => {
  const { loyaltyStore } = useStores();

  const { displayTutorial } = loyaltyStore;

  useEffect(() => {
    (async () => {
      await loyaltyStore.getLoyaltyConfig();
    })();
  }, []);

  if (displayTutorial !== true) return null;

  return (
    <section className={styles.iframe_video_container}>
      <div className="container">
        <IframeVideo idForScroll={idForScroll} />
      </div>
    </section>
  );
};
